import { render, staticRenderFns } from "./PatientRecap.vue?vue&type=template&id=17f7f7aa&"
import script from "./PatientRecap.vue?vue&type=script&lang=js&"
export * from "./PatientRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports